import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, createFilePath, convertStylesStringToObject, isVideo } from '../../utils/obj-utils';
import Detailss from '../../elements/InnerPageDetail';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import './style.scss';

export default function index(props) {
  const { fields } = props;
  const swiperRef = useRef(null);
  const [flag, setFlag] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [VideoUrl, setVideoUrl] = useState(null);
  const isMobile = isMobileFun();
  const id = props?.params?.pagename;
  const containerRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [VideoIndex, setVideoIndex] = useState(0);
  const [isclickNextPrev, setIsclickNextPrev] = useState(false);

  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
  };
  const swiperItem = (item) => {
    return (
      <>
        {item?.fields[`${getPrefixField('img', isMobile)}`]?.value && item?.fields?.subslists.length <= 0 && (
          <>
            {item?.fields[getPrefixField('lo', isMobile)]?.value && isMobile && (
              <img
                alt="广汽本田"
                className="lo"
                style={convertStylesStringToObject(item?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                src={`${createFilePath(item?.fields[getPrefixField('lo', isMobile)]?.value)}`}
              />
            )}
            <div className="video" style={convertStylesStringToObject(item?.fields[`${getPrefixField('videostyle', isMobile)}`]?.value)}>
              <img
                alt="广汽本田"
                className="img"
                style={convertStylesStringToObject(item?.fields[`${getPrefixField('imgstyle', isMobile)}`]?.value)}
                src={`${createFilePath(item?.fields[getPrefixField('img', isMobile)]?.value)}`}
              />
              <img
                alt="play"
                className="icon"
                src={`${createFilePath(item?.fields[getPrefixField('icon', isMobile)]?.value)}`}
                style={convertStylesStringToObject(item?.fields[`${getPrefixField('iconstyle', isMobile)}`]?.value)}
                onClick={() => {
                  setFlag(true);
                  setVideoUrl(item?.fields?.detailurl?.value);
                  window.Dmp.clickAction(item?.fields?.dmp?.value, createFilePath(item?.fields[`${getPrefixField('videourl', isMobile)}`]?.value));
                }}
              />
              {item?.fields[getPrefixField('text', isMobile)]?.value && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: item?.fields[getPrefixField('text', isMobile)]?.value.replaceHtml()
                  }}
                ></div>
              )}
              {item?.fields[getPrefixField('lo', isMobile)]?.value && !isMobile && (
                <img
                  alt="广汽本田"
                  className="lo"
                  style={convertStylesStringToObject(item?.fields[`${getPrefixField('lostyle', isMobile)}`]?.value)}
                  src={`${createFilePath(item?.fields[getPrefixField('lo', isMobile)]?.value)}`}
                />
              )}
            </div>
          </>
        )}
        {item?.fields?.subslists.length > 0 && (
          <div className="lists">
            {item?.fields[getPrefixField('moretips', isMobile)]?.value && (
              <div
                className="more"
                dangerouslySetInnerHTML={{
                  __html: item?.fields[getPrefixField('moretips', isMobile)]?.value.replaceHtml()
                }}
              ></div>
            )}

            <div className="subslists">
              {item?.fields?.subslists.map((item2, index2) => {
                return (
                  <div
                    className="subitem"
                    key={index2}
                    style={convertStylesStringToObject(item2?.fields[`${getPrefixField('subitemstyle', isMobile)}`]?.value)}
                  >
                    {item2?.fields[getPrefixField('img', isMobile)]?.value && (
                      <img
                        alt="广汽本田"
                        className="img"
                        style={convertStylesStringToObject(item2?.fields[`${getPrefixField('imgstyle', isMobile)}`]?.value)}
                        src={`${createFilePath(item2?.fields[getPrefixField('img', isMobile)]?.value)}`}
                      />
                    )}
                    {item2?.fields?.detailurl?.value && (
                      <img
                        alt="play"
                        className="icon"
                        src={`${createFilePath(item2?.fields[getPrefixField('icon', isMobile)]?.value)}`}
                        style={convertStylesStringToObject(item2?.fields[`${getPrefixField('iconstyle', isMobile)}`]?.value)}
                        onClick={() => {
                          setVideoUrl(item2?.fields?.detailurl?.value);
                          setFlag(true);
                          window.Dmp.clickAction(
                            item2?.fields?.dmp?.value,
                            createFilePath(item2?.fields[`${getPrefixField('videourl', isMobile)}`]?.value)
                          );
                        }}
                      />
                    )}
                    {item2?.fields[getPrefixField('subtext', isMobile)]?.value && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item2?.fields[getPrefixField('subtext', isMobile)]?.value.replaceHtml()
                        }}
                      ></div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <>
      <div className="price_special_v1" id={id}>
        <div className="hash"></div>
        <div className="con" ref={containerRef}>
          {fields?.lists.length > 0 && (
            <>
              {!isMobile ? (
                <>
                  <Swiper
                    ref={swiperRef}
                    slidesPerView={1}
                    className="swiper"
                    spaceBetween={0}
                    initialSlide={0}
                    observer={true}
                    resizeObserver={true}
                    updateOnWindowResize={true}
                    modules={[Pagination, Navigation]}
                    navigation={{
                      prevEl: navigationPrevRef.current,
                      nextEl: navigationNextRef.current,
                      disabledClass: 'disabled'
                    }}
                    onSwiper={(swiper) => {
                      setTimeout(() => {
                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                        swiper.params.navigation.nextEl = navigationNextRef.current;
                        swiper.navigation.destroy();
                        swiper.navigation.init();
                        swiper.navigation.update();
                      });
                    }}
                    onSlideChangeTransitionEnd={(e) => {
                      setSwiperIndex(e.activeIndex);
                    }}
                    onSlidePrevTransitionEnd={(e) => {
                      if (fields?.swpprevdmp?.value && !isclickNextPrev) {
                        window.Dmp.clickAction(fields?.swpprevdmp?.value);
                      }
                      setIsclickNextPrev(false);
                    }}
                    onSlideNextTransitionEnd={(e) => {
                      if (fields?.swpnextdmp?.value && !isclickNextPrev) {
                        window.Dmp.clickAction(fields?.swpnextdmp?.value);
                      }
                      setIsclickNextPrev(false);
                    }}
                  >
                    {fields?.lists.map((item, index) => {
                      return (
                        <SwiperSlide className="item" key={index}>
                          {swiperItem(item)}
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  <div
                    className="next"
                    ref={navigationNextRef}
                    data-html-item={fields?.nextdmp?.value}
                    style={convertStylesStringToObject(fields[`${getPrefixField('nexticonstyle', isMobile)}`]?.value)}
                    onClick={() => {
                      setIsclickNextPrev(true);
                    }}
                  >
                    <img className="icon" src={createFilePath(fields[`${getPrefixField('nexticon', isMobile)}`]?.value)} alt="广汽本田" />
                  </div>
                  <div
                    className="prev"
                    ref={navigationPrevRef}
                    data-html-item={fields?.prevdmp?.value}
                    style={convertStylesStringToObject(fields[`${getPrefixField('previconstyle', isMobile)}`]?.value)}
                    onClick={() => {
                      setIsclickNextPrev(true);
                    }}
                  >
                    <img className="icon" src={createFilePath(fields[`${getPrefixField('previcon', isMobile)}`]?.value)} alt="广汽本田" />
                  </div>
                </>
              ) : (
                <>
                  {fields?.lists.map((item, index) => {
                    return (
                      <div className="item" key={index}>
                        {swiperItem(item)}
                      </div>
                    );
                  })}
                </>
              )}
            </>
          )}
        </div>

        {flag && VideoUrl && (
          <Detailss routePath={VideoUrl} {...fields} close={() => setFlag(false)} isModal={document.documentElement.clientWidth <= 1024} />
        )}
      </div>
    </>
  );
}
